"use client";

import { createContext, useContext, useRef } from "react";
import { useStore } from "zustand";
import { createOverviewPreviewStore } from "../../overview-preview-store";
export const OverviewPreviewStoreContext = createContext(undefined);
export const OverviewPreviewProvider = ({
  children,
  slug
}) => {
  const storeRef = useRef(null);
  if (storeRef.current === null) {
    storeRef.current = createOverviewPreviewStore(slug);
  }
  return <OverviewPreviewStoreContext.Provider value={storeRef.current}>
      {children}
    </OverviewPreviewStoreContext.Provider>;
};
export const useOverviewPreviewStore = selector => {
  const overviewPreviewStoreContext = useContext(OverviewPreviewStoreContext);
  if (!overviewPreviewStoreContext) {
    throw new Error("useOverviewPreviewStore must be used within OverviewPreviewProvider");
  }
  return useStore(overviewPreviewStoreContext, selector);
};